import * as React from "react";
import { SVGProps } from "react";

const Received = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.6 20.049H19.2C19.5556 20.049 19.85 19.7546 19.85 19.399C19.85 19.0434 19.5556 18.749 19.2 18.749H5.6C5.24439 18.749 4.95 19.0434 4.95 19.399C4.95 19.7546 5.24439 20.049 5.6 20.049Z"
      fill="#45A159"
      stroke="#45A159"
      strokeWidth="0.1"
    />
    <path
      d="M19.2593 5.05735C19.3892 4.92748 19.45 4.76254 19.45 4.598C19.45 4.43345 19.3892 4.26851 19.2593 4.13864C19.0078 3.88712 18.5921 3.88712 18.3406 4.13864L7.1406 15.3386C6.88907 15.5902 6.88907 16.0058 7.1406 16.2574C7.39212 16.5089 7.80778 16.5089 8.05931 16.2574L19.2593 5.05735Z"
      fill="#45A159"
      stroke="#45A159"
      strokeWidth="0.1"
    />
    <path
      d="M15.816 16.4479C16.1716 16.4479 16.466 16.1536 16.466 15.7979C16.466 15.4423 16.1716 15.1479 15.816 15.1479L8.25 15.1479L8.25 7.58195C8.25 7.22633 7.95561 6.93195 7.6 6.93195C7.24439 6.93195 6.95 7.22633 6.95 7.58195L6.95 15.7979C6.95 16.1536 7.24439 16.4479 7.6 16.4479L15.816 16.4479Z"
      fill="#45A159"
      stroke="#45A159"
      strokeWidth="0.1"
    />
  </svg>
);
export default Received;
